import { connect } from 'react-redux';
import * as appUI from '../../../modules/uis/app';
import RootState from '../../../modules/rootState';
import { Props } from './Indicator';
import Indicator from './Indicator';

const mapStateToProps = (state: RootState): Props => ({
    message: appUI.selectors.getMessageIndicator(state)
});

export default connect(mapStateToProps)(Indicator);


// WEBPACK FOOTER //
// ./src/components/shared/Indicator/Indicator.container.ts